import { Toaster as SonnerToaster, toast } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="top-right"
      theme="light"
      richColors={false}
      toastOptions={{
        unstyled: false,
        classNames: {
          toast:
            "!bg-[var(--color-surface)] !border !border-[var(--color-line-strong)] !text-[var(--color-ink)] !shadow-[var(--shadow-lift)] !rounded-md",
          title: "!text-[var(--color-ink)] !font-medium",
          description: "!text-[var(--color-ink-muted)]",
          actionButton: "!bg-[var(--color-gold)] !text-[var(--color-gold-ink)] !rounded-sm",
          cancelButton:
            "!bg-transparent !text-[var(--color-ink-muted)] !border !border-[var(--color-line)]",
          success: "!border-l-2 !border-l-[var(--color-success)]",
          error: "!border-l-2 !border-l-[var(--color-danger)]",
          info: "!border-l-2 !border-l-[var(--color-info)]",
          warning: "!border-l-2 !border-l-[var(--color-warning)]",
        },
      }}
    />
  );
}

export { toast };
